module.exports = __webpack_public_path__ + "img/ico051.57135979.svg";